import BaseApi from "@/core/HttpResources/BaseApi";
import IndicatorValue from "@/models/indicator/indicatorValue.model";
import IndicatorModel from '../models/indicator/indicator.model';
export default class IndicatorService {


    async save(subIndicators:Array<IndicatorModel>) {
        var baseApi = new BaseApi("Indicators/SaveIndicator");
        return new Promise<IndicatorModel>((resolve, reject) =>
          baseApi.request(
            "POST",
            String(),
            subIndicators,
            {
            },
            response => resolve(response.data),
            reject,
            () => { }
          )
        );
      }
      async saveIndicatorValue(values:Array<IndicatorValue>) {
        var baseApi = new BaseApi("IndicatorValues/SaveIndicatorValue");
        return new Promise<IndicatorModel>((resolve, reject) =>
          baseApi.request(
            "POST",
            String(),
            values,
            {
            },
            response => resolve(response.data),
            reject,
            () => { }
          )
        );
      }
      async getIndicatorChild(id: number): Promise<Array<any>> {
        var baseApi = new BaseApi("Indicators/GetIndicatorById/" + id);
        return new Promise<Array<any>>((resolve, reject) =>
          baseApi.request(
            "GET",
            String(),
            null,
            {},
            response => resolve(response.data),
            reject,
            () => { }
          )
        );
      }

      async getIndicator(): Promise<Array<any>> {
        var baseApi = new BaseApi("IndicatorValues/GetAllIndicator");
        return new Promise<Array<any>>((resolve, reject) =>
          baseApi.request(
            "GET",
            String(),
            null,
            {},
            response => resolve(response.data),
            reject,
            () => { }
          )
        );
      }

 

 

}
